export const ENTITLEMENTS_RESOURCE_KEYS = [
  'entitlements',
  'expiredEntitlements',
  'approvals',
  'entitlementsMetadata',
  'dataFeedContext',
] as const;
